<template>

    <PartnerLayout :title="partnerSettings.name">

        <div class="min-h-screen bg-indigo-50">
            <main class="py-8">

                <PartnerHeader/>

                <div class="mt-6 max-w-3xl mx-auto grid grid-cols-1 gap-6 sm:px-6 lg:max-w-7xl lg:grid-flow-col-dense">


                    <dl>
                        <Stats/>

                        <Dev class="mt-5"/>
                    </dl>

                    <Timeline/>


                </div>


            </main>
        </div>

    </PartnerLayout>

</template>

<script>
import PartnerLayout from "../../Layouts/PartnerLayout";
import PartnerHeader from "./PartnerHeader";
import Stats from "./Stats";
import TimelineComponent from "./TimelineComponent";
import Dev from "./Dev";
export default {
    name: "Show",
    components: {Stats, PartnerHeader, PartnerLayout, Timeline: TimelineComponent, Dev},
    data(){
        return {
            partnerSettings: this.$page.props.partnerSettings,
        }
    }
}
</script>

<style scoped>

</style>
